<template>
  <div>
    <b-row>
      <b-col>
        <b-row
          class="content-header"
        >
          <b-col
            class="content-header-left mb-2"
            cols="12"
            md="9"
          >
            <b-row class="breadcrumbs-top">
              <b-col cols="12">
                <h2 class="content-header-title float-left pr-1 mb-0">
                  Transaksi
                </h2>
                <div class="breadcrumb-wrapper">
                  <b-breadcrumb>
                    <b-breadcrumb-item
                      :to="{ name: 'dashboard-mechtech' }"
                    >
                      <feather-icon
                        icon="HomeIcon"
                        size="16"
                        class="align-text-top"
                      />
                    </b-breadcrumb-item>
                    <b-breadcrumb-item
                      :active="true"
                    >
                      Daftar Transaksi
                    </b-breadcrumb-item>
                  </b-breadcrumb>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-for="(transaction, index) in transactions" :key="index">
      <b-col>
        <b-card class="rounded-lg">
          <b-card-body>
            <b-row>
              <b-col md="8">
                <h4>{{ transaction.name }}</h4>
              </b-col>
              <b-col md="4" class="d-flex justify-content-end">
                <strong>{{ formatDate(transaction.date) }}</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col>
                    <span>
                      <strong>Transaction Status: </strong>{{ formatToIDR(transaction.amount) }}
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col>
                    <span>
                      <strong>Amount: </strong>{{ transaction.status }}
                    </span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { formatDate } from '@core/utils/filter'

export default {
  name: 'UserTransactionList',
  setup() {
    return {
      formatDate,
    }
  },
  data() {
    return {
      transactions: [
        {
          id: 1,
          name: "Payment Subscriptions",
          amount: 250000,
          date: "2024-08-17T09:34:47.000000Z",
          status: "Success",
        },
        {
          id: 2,
          name: "Payment Subscriptions",
          amount: 250000,
          date: "2024-08-17T09:34:47.000000Z",
          status: "Success",
        },
      ]
    }
  },
  computed: {
    finalTotal () {
      return this.summary.subTotal - this.summary.discountTotal
    }
  },
  methods: {
    formatToIDR(value) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });

      return formatter.format(value);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

  h2 {
    font-size: 1.25rem;

    @include media-breakpoint-up(sm) {
      font-size: 1.25rem;
    }
    @include media-breakpoint-up(md) {
      font-size: 1.75rem;
    }
    @include media-breakpoint-up(lg) {
      font-size: 1.75rem;
    }
    @include media-breakpoint-up(xl) {
      font-size: 1.75rem;
    }
  }

</style>
